import { render, staticRenderFns } from "./prodTime.vue?vue&type=template&id=10a61cd6"
import script from "./prodTime.vue?vue&type=script&lang=js"
export * from "./prodTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports